import React from "react";
import "./App.css";

import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import RecordingPage from "./components/RecordingPage";
import TermsPage from "./components/TermsPage";
import MetaData from "./components/MetaData";
import HomePage from "./components/HomePage";
import AboutPage from "./components/AboutPage";
import ContactPage from "./components/ContactPage";
import ThankYouPage from "./components/ThankYouPage";
import {
  setCurrentPage,
  getDefaultAppState,
  handleChange,
  handleToggle,
  handleSubmit,
  clickExistingUser,
  unsetModal,
  handleSuccessfulToggle,
} from "./components/HelperFunctions";
import { Component } from "react";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "./firebase";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = getDefaultAppState();

    this.uiConfig = {
      signInFlow: "popup",
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      ],
      callbacks: {
        signInSuccess: () => false,
      },
    };
  }

  componentDidMount = () => {
    firebase.auth().onAuthStateChanged((user) => {
      this.setState(
        {
          isLoggedIn: !!user,
          providerId: !!user ? user.uid : "Anonymous",
        },
        () => {
          if (!this.state.isLoggedIn) this.setState(getDefaultAppState());
          else this.setState({ providerId: firebase.auth().currentUser.uid }, handleSuccessfulToggle(this));
        }
      );
    });
  };

  setAppDefault = () => {
    let appState = getDefaultAppState();
    appState.currentPage = this.state.currentPage;
    this.setState(appState);
  };

  getDisplayName = () => {
    if (this.state.name !== "Anonymous") {
      return this.state.name;
    }
    else {
      if (this.state.isLoggedIn) {
        return firebase.auth().currentUser.displayName;
      }
      else {
        return "";
      }
    }
  }

  render() {
    return (
      <div>
        <div id="body">
          <NavBar
            appState={this.state}
            login={() => {
              this.setState({ tryLogin: !this.state.tryLogin });
            }}
            logout={() => {
              this.setState(getDefaultAppState(), () => firebase.auth().signOut());
            }}
            setCurrentPage={(currentPage) => setCurrentPage(this, currentPage)}
          />
          <h1 className="flex-container">
            Hello{" "}
            {this.getDisplayName()/* {!!firebase.auth().currentUser
              ? firebase.auth().currentUser.displayName
              : this.state.name} */}
          </h1>
          <div>
            {this.state.isLoggedIn === false && this.state.tryLogin ? (
              <StyledFirebaseAuth
                uiConfig={this.uiConfig}
                firebaseAuth={firebase.auth()}
              />
            ) : null}
          </div>
          {this.state.currentPage === "home" ? (
            <HomePage
              appState={this.state}
              login={() => {
                this.setState({ tryLogin:true });
              }}
              setAppDefault={this.setAppDefault}
              setCurrentPage={(currentPage) =>
                setCurrentPage(this, currentPage)
              }
            ></HomePage>
          ) : null}
          {this.state.currentPage === "about" ? (
            <AboutPage
              appState={this.state}
              setAppDefault={this.setAppDefault}
            ></AboutPage>
          ) : null}

          {this.state.currentPage === "contact" ? (
            <ContactPage
              appState={this.state}
              setAppDefault={this.setAppDefault}
            ></ContactPage>
          ) : null}

          {this.state.currentPage === "thank" ? (
            <ThankYouPage appState={this.state}></ThankYouPage>
          ) : null}

          {this.state.currentPage === "terms" ? (
            <TermsPage
              appState={this.state}
              setCurrentPage={(currentPage) =>
                setCurrentPage(this, currentPage)
              }
              setAppDefault={this.setAppDefault}
            ></TermsPage>
          ) : null}

          {this.state.currentPage === "meta" ? (
            <MetaData
              appState={this.state}
              setAppDefault={this.setAppDefault}
              handleChange={(e) => handleChange(this, e)}
              handleSubmit={(e) => handleSubmit(this, e)}
              handleToggle={(e) => handleToggle(this, e)}
              handleSuccessfulToggle={() => handleSuccessfulToggle(this)}
              clickExistingUser={(e) => clickExistingUser(this, e)}
              unsetModal={(e) => unsetModal(this, e)}
            ></MetaData>
          ) : null}

          {this.state.currentPage === "record" ? (
            <RecordingPage
              appState={this.state}
              setCurrentPage={(currentPage) =>
                setCurrentPage(this, currentPage)
              }
            ></RecordingPage>
          ) : null}
        </div>
        <div id="footer">
          <Footer />
        </div>
      </div>
    );
  }
}

export default App;
